<template>
  <!-- No close button, as classic: accept or decline; Escape is cancelled (reopen) -->
  <dialog v-if="offer" ref="el" class="v5-dialog" aria-labelledby="v5-so-h" @cancel.prevent @close="reopen">
    <div class="v5-dialog__box">
      <div class="v5-so__who">
        <img class="v5-avatar v5-so__pic" :src="offer.creator.picture_url" alt="">
        <span class="v5-so__tx">
          <b>{{ offer.creator.name }}</b>
          <small v-if="offer.creator.twitch?.live">{{ offer.creator.twitch.login }}, <span class="num">{{ offer.creator.twitch.viewer_count }}</span></small>
          <small>{{ t('v5_ui_shell.seat_sub', { region: offer.region.name, n: offer.member_count }) }}</small>
        </span>
        <span v-if="offer.creator.twitch?.live" class="v5-chip v5-chip--bad">{{ t('v5_ui_shell.seat_live') }}</span>
      </div>
      <div class="v5-dialog__head"><h2 id="v5-so-h">{{ t('v5_ui_shell.seat_title', { name: offer.creator.name }) }}</h2></div>
      <p class="v5-dialog__text">{{ t('v5_ui_shell.seat_body', { name: offer.creator.name }) }}</p>
      <p v-if="offer.play_mode?.friendly_name || offer.cs_map" class="v5-so__mode">
        <img v-if="offer.cs_map" :src="pinUrl(offer.cs_map.name)" alt="" width="20" height="20">
        {{ [offer.play_mode?.friendly_name, offer.cs_map?.friendly_name].filter(Boolean).join(', ') }}
      </p>
      <button class="v5-btn-p" type="button" :disabled="busy" @click="accept">{{ t('v5_ui_shell.seat_accept') }}</button>
      <button class="v5-btn v5-so__no" type="button" :disabled="busy" @click="decline">{{ t('v5_ui_shell.seat_decline') }}</button>
      <small class="v5-so__note">{{ t('v5_ui_shell.seat_note') }}</small>
    </div>
  </dialog>
</template>

<script setup>
import { ref, watch, nextTick } from 'vue';
import { useI18n } from 'vue-i18n';
import { pinUrl } from '../../utils/lan_party';
import useSeatOffer from '../../composables/useSeatOffer';

// A LAN party seat offer: the classic accept and decline (useSeatOffer).
const { t } = useI18n();
const el = ref(null);
const {
  busy, offer, decline, accept,
} = useSeatOffer();

watch(offer, (o) => { if (o) nextTick(() => el.value?.showModal?.()); }, { immediate: true });
// Chromium only lets a page cancel Escape after a user activation; a forced close reopens it
function reopen() { if (el.value?.isConnected) el.value.showModal?.(); }
</script>

<style>
.v5-so__who { display: flex; align-items: center; gap: 10px; padding: 10px; border: 1px solid var(--rule); border-radius: var(--r); background: var(--raised); }
.v5-so__pic { width: 40px; height: 40px; }
.v5-so__tx { display: grid; flex: 1; min-width: 0; }
.v5-so__tx small { color: var(--fg-2); font-size: var(--t-xs); }
.v5-so__mode { display: flex; align-items: center; gap: 8px; margin: 0; color: var(--fg-2); font-size: var(--t-sm); font-weight: 600; }
.v5-so__no { min-height: 44px; }
.v5-so__note { color: var(--fg-2); font-size: var(--t-xs); text-align: center; }
</style>
